/** 客诉手机版作业页（PRD 指定地址，Lark 卡片链接也落到这里）。 */
export const MOBILE_WORK_PATH = '/complaint-platform/work-mobile';
export const MOBILE_LOGIN_PATH = `${MOBILE_WORK_PATH}/login`;

/** 卡片 / 链接参数：taskId 定位到某条；action=start 进来即记为已响应，view 只查看。 */
export const PARAM_TASK_ID = 'taskId';
export const PARAM_ACTION = 'action';

/** 登录页跳转地址：带上当前地址（含 taskId / action），登录后原样回跳。 */
export const mobileLoginUrl = (currentPathWithSearch: string) =>
  `${MOBILE_LOGIN_PATH}?redirect=${encodeURIComponent(currentPathWithSearch)}`;

/** 只允许回跳到手机版自己的页面，防止 redirect 参数被拿来跳到站外。 */
export const safeMobileRedirect = (redirect?: string | null): string =>
  redirect && redirect.startsWith(`${MOBILE_WORK_PATH}`) && !redirect.startsWith(MOBILE_LOGIN_PATH)
    ? redirect
    : MOBILE_WORK_PATH;
